import React,{useState,useEffect} from 'react';
import { Table, Form,Button } from 'react-bootstrap';
import "./cgi.css"

function RatingTable({ title, name, options, selected, handler, disabled }) {
    const handleClick = (value) => {
        if (!disabled) {
            handler(name, value); // notify parent
        }
    };

    return (
        <div className="mb-4">
            <h5 className="mb-3">{title}</h5>
            <Table bordered hover responsive>
                <thead className="table-light">
                <tr>
                    <th style={{ width: '10%' }}>Score</th>
                    <th>Meaning</th>
                    <th style={{ width: '15%' }}>Select</th>
                </tr>
                </thead>
                <tbody>
                {options.map(([value, label]) => {
                    const isSelected = selected !== null && Number(selected) === value;

                    return (
                        <tr
                            key={value}
                            className={isSelected ? 'selected-row' : ''}
                            onClick={() => handleClick(value)}
                            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                        >
                            <td>{value}</td>
                            <td>{label}</td>
                            <td onClick={(e) => e.stopPropagation()}>
                                <Button
                                    size="sm"
                                    variant={isSelected ? 'success' : 'outline-secondary'}
                                    className="w-100"
                                    disabled={disabled}
                                    onClick={() => handleClick(value)}
                                >
                                    {isSelected ? 'Selected' : 'Select'}
                                </Button>
                            </td>
                        </tr>
                    );
                })}
                </tbody>
            </Table>
        </div>
    );
}



// export default RatingTable;

function EfficacyMatrixTable({ selected, handler, name, disabled }) {
    const efficacyMatrix = {
        rows: [
            { key: 'marked', label: 'Marked', description: 'Complete or nearly complete remission of all symptoms' },
            { key: 'moderate', label: 'Moderate', description: 'Partial remission of symptoms' },
            { key: 'minimal', label: 'Minimal', description: 'Slight improvement, doesn’t alter care' },
            { key: 'unchanged', label: 'Unchanged or worse', description: '' },
        ],
        columns: [
            { key: 'none', label: 'None' },
            { key: 'mild', label: 'Do not significantly interfere' },
            { key: 'moderate', label: 'Significantly interferes' },
            { key: 'severe', label: 'Outweighs therapeutic effect' },
        ],
        codes: [
            ['01', '02', '03', '04'],
            ['05', '06', '07', '08'],
            ['09', '10', '11', '12'],
            ['13', '14', '15', '16'],
        ],
    };

    const handleSelect = (code) => {
        if (!disabled) {
            handler(name, code);
        }
    };

    return (
        <div className="mb-4">
            <h5>3. Efficacy index</h5>
            <p><strong>Rate this item on the basis of <em>drug effect only</em>.</strong></p>

            <Table bordered responsive hover className="text-center">
                <thead className="table-light">
                <tr>
                    <th>Therapeutic Effect \ Side Effects</th>
                    {efficacyMatrix.columns.map((col) => (
                        <th key={col.key}>{col.label}</th>
                    ))}
                </tr>
                </thead>
                <tbody>
                {efficacyMatrix.rows.map((row, rowIndex) => (
                    <tr key={row.key}>
                        <td className="text-start">
                            <strong>{row.label}</strong>
                            <div className="text-muted small">{row.description}</div>
                        </td>
                        {efficacyMatrix.columns.map((col, colIndex) => {
                            const code = efficacyMatrix.codes[rowIndex][colIndex];
                            const isChecked = selected === code;

                            return (
                                <td
                                    key={code}
                                    onClick={() => handleSelect(code)}
                                    className={`matrix-checkbox-cell ${isChecked ? 'selected-cell' : ''}`}
                                    style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                                >
                                    <Form.Check
                                        type="checkbox"
                                        id={`efficacy-${code}`}
                                        checked={isChecked}
                                        disabled={disabled}
                                        onChange={() => handleSelect(code)}
                                        onClick={(e) => e.stopPropagation()}
                                        label={<strong>{code}</strong>}
                                        className="matrix-checkbox"
                                    />
                                </td>
                            );
                        })}
                    </tr>
                ))}
                </tbody>
            </Table>
        </div>
    );
}





function CGI(props) {
    const [cgiState, setCgiState] = useState(() => props.data || {
        severity: null,
        improvement: null,
        efficacy: null,
    });
    const [disabled, setDisabled] = useState(props.disabled ?? false);
    const hasInitialized = React.useRef(false);

    useEffect(() => {
        if (props.data && !hasInitialized.current) {
            setCgiState(props.data);
            hasInitialized.current = true;
        }
    }, [props.data]);

    const handleCGIChange = (name, value) => {
        setCgiState(prev => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        if (props.handler) {
            props.handler('cgi', cgiState);
        }
    }, [cgiState]);
    const severityOptions = [
        [0, 'Not assessed'],
        [1, 'Normal, not at all ill'],
        [2, 'Borderline mentally ill'],
        [3, 'Mildly ill'],
        [4, 'Moderately ill'],
        [5, 'Markedly ill'],
        [6, 'Severely ill'],
        [7, 'Among the most extremely ill patients'],
    ];

    const improvementOptions = [
        [0, 'Not assessed'],
        [1, 'Very much improved'],
        [2, 'Much improved'],
        [3, 'Minimally improved'],
        [4, 'No change'],
        [5, 'Minimally worse'],
        [6, 'Much worse'],
        [7, 'Very much worse'],
    ];
    useEffect(() => {
        props.handler('cgi',cgiState)


    }, [cgiState]);




    const [efficacyCode, setEfficacyCode] = useState(null);

    return (
        <div className="container mt-4">
            <h1>Clinical Global Index</h1>
            <RatingTable
                title="1. Severity of illness"
                name="severity"
                options={severityOptions}
                selected={cgiState.severity}
                handler={handleCGIChange}
                disabled={props.disabled}
            />

            <RatingTable
                title="2. Improvement since admission"
                name="improvement"
                options={improvementOptions}
                selected={cgiState.improvement}
                handler={handleCGIChange}
                disabled={props.disabled}
            />

            <EfficacyMatrixTable
                name="efficacy"
                selected={cgiState.efficacy}
                handler={handleCGIChange}
                disabled={props.disabled}
            />
        </div>
    );
}

// export default CGI;
export default CGI;